module.exports = __webpack_public_path__ + "static/img/3116.add7afd5.png";